import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { ApiService } from '../../../Services/api.service';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ConfirmPopupComponent } from '../../../Common/Components/confirm-popup/confirm-popup.component';
import { NzInputDirective, NzInputModule } from "ng-zorro-antd/input";
import { RichTextFieldComponent } from '../../../Common/Components/rich-text-field/rich-text-field.component';
import { Toolbar } from 'ngx-editor';

@Component({
  selector: 'app-catalog-attribute-add-edit',
  standalone: true,
  imports: [NzButtonModule, CommonModule, NzCollapseModule, DragDropModule, 
    ConfirmPopupComponent, NzSwitchModule, FormsModule, NzIconModule, 
    ReactiveFormsModule, NzSelectModule, NzTagModule, NzInputModule, RichTextFieldComponent],
  templateUrl: './catalog-attribute-add-edit.component.html',
  styleUrl: './catalog-attribute-add-edit.component.scss'
})
export class CatalogAttributeAddEditComponent {

  constructor(private fb: FormBuilder, public apiService: ApiService) {  }
  activeTab: string = "Section A";
  actionValue: string = "";
  bulletList: any = ['0'];
  inValidAttrValForm: boolean = false;
  @Input() openUpdateWindow: any = false;
  showModal: boolean = false;
  linkedStatus = [
    {
      id: 1, name: "Section A", clicked: true
    },
    {
      id: 2, name: "Section B", clicked: false
    }
  ];
  addEditCatalogForm: FormGroup = new FormGroup({});
  attributeArrayForm: FormGroup = new FormGroup({});
  attrValArrayForm: FormGroup = new FormGroup({});
  @ViewChildren('panelRef', { read: ElementRef }) panelElements!: QueryList<ElementRef>;
  @Input() salsifyProduct: boolean = false;
  @Output() emitData = new EventEmitter();
  @Input() masterCatalogAttirbutes: any;
  @Input() productInfo: any;
  @Input() attributeFormatSwitchValue: any;
  @Input() isEditPage: boolean = false;
  attrSwitch: boolean = true;
  attrSwitchConfirmed: boolean = true;
  modalMessage: string = '';
  attrArrayIndex: any;
  toolbar: Toolbar = [
        ['bold', 'italic'],
        ['underline', 'strike']
      ];

  ngOnInit(): void {
    this.attrSwitch = this.attributeFormatSwitchValue;
    this.attrSwitchConfirmed = this.attributeFormatSwitchValue;

    this.initAddForm();
  }
  initAddForm() {
    this.addEditCatalogForm = this.fb.group({
      attributeArray: this.fb.array([], Validators.minLength(1))
    });
    this.addItemtoAttributeArray();

  }

  addItemtoAttributeArray(action?: string) {
    const form = this.attrArray as FormArray;
    form.clear();
    var filteredArray: any = [];

    if (this.attrSwitch && this.attrSwitchConfirmed && this.masterCatalogAttirbutes) {
      filteredArray = this.masterCatalogAttirbutes.filter((res: any) => res.salsify == 1);
    }
    else if (this.masterCatalogAttirbutes) {
      filteredArray = this.masterCatalogAttirbutes.filter((res: any) => res.salsify == 0);
    }

    let productArrayData = this.productInfo?.value ? this.productInfo.value : [];

    for (let i = 0; i <= filteredArray.length - 1; i++) {
      this.attributeArrayForm = this.fb.group({
        attributeName: [filteredArray[i].displayName],
        attributeValue: [''],
        collapse: [true],
        attributeId: [filteredArray[i].attributeId],
        attrValArray: this.fb.array([])
      });
      this.attrArray.push(this.attributeArrayForm);

      productArrayData.map((node: any) => {
        if (node.attributeId == filteredArray[i].attributeId) {
          if (node.attrValArray.length > 0) {
            node.attrValArray.map((node1: any) => {
              const attrValArr = this.attributeArrayForm.get('attrValArray') as FormArray;
              this.attrValArrayForm = this.fb.group({
                attributeValue: [node1.attributeValue]
              });
              attrValArr.push(this.attrValArrayForm);
            })
          }
        }
      })

    }

    this.actionValue = action ? action : '';
    if (!this.attrSwitch && !this.attrSwitchConfirmed) {
      const attrArray = this.attrArray.at(0) as FormGroup;
      const attrValArr = attrArray.get('attrValArray') as FormArray;
      this.attrValArrayForm = this.fb.group({
        attributeValue: ['']
      });
      attrValArr.push(this.attrValArrayForm);
    }
    this.showModal = false;
  }

  get attrArrayControls() {
    return (this.addEditCatalogForm.controls["attributeArray"] as FormArray).controls as FormGroup[];
  }

  get attrArrayValControls() {
    return this.attributeArrayForm.get('attrValArray') as FormArray;
  }

  attrArrayValuesControls(index: any) {
    const attrArray = this.attrArray.at(index) as FormGroup;
    const attrValArr = attrArray.get('attrValArray') as FormArray;
    return attrValArr;
  }

  attrValArrayControls(i: number) {
    const attrArray = this.attrArray.at(i) as FormGroup;
    const attrValArr = attrArray.get('attrValArray') as FormArray;
    return attrValArr.controls as FormGroup[];
  }

  attrValArray(i: number) {
    const attrArray = this.attrArray.at(i) as FormGroup;
    const attrValArr = attrArray.get('attrValArray') as FormArray;
    return attrValArr;
  }

  addItemtoAttrValArray(action: string, index: number, form: FormGroup) {
    if (this.attrSwitch && this.attrSwitchConfirmed) {
      if (!form.controls['attributeValue'].value) {
        return;
      }
    }
    form.controls['attributeValue'].setErrors(null);
    const attrArray = this.attrArray.at(index) as FormGroup;
    const attrValArr = attrArray.get('attrValArray') as FormArray;
    if (this.attrSwitch && this.attrSwitchConfirmed) {
      this.attrValArrayForm = this.fb.group({
        attributeValue: [form.controls['attributeValue'].value]
      });
      form.controls['attributeValue'].setValue('');
    }
    else {
      this.attrValArrayForm = this.fb.group({
        attributeValue: ['']
      });
    }
    attrValArr.push(this.attrValArrayForm);
    this.actionValue = action ? action : '';
    this.inValidAttrValForm = false;
  }

  focusPanel() {
    this.panelElements?.last.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.actionValue = '';
  }

  ngAfterViewInit(): void {
    this.panelElements.changes.subscribe(node => {
      if (this.actionValue)
        this.focusPanel();
    })
  }

  handleCollapse(i: number) {
    let attrList = this.attrArray.value;
    attrList[i].collapse = !attrList[i].collapse;
    this.attrArray.patchValue(attrList);

  }

  get attrArray() {
    return this.addEditCatalogForm.controls["attributeArray"] as FormArray;
  }

  deleteAttrArrayItem(attrArrayIndex: number) {
    const attrArray = this.attrArray.at(attrArrayIndex) as FormGroup;
    const attrValArr = attrArray.get('attrValArray') as FormArray;
    attrValArr.clear();
    if (!this.attrSwitch && !this.attrSwitchConfirmed) {
      this.attrValArrayForm = this.fb.group({
        attributeValue: ['']
      });
      attrValArr.push(this.attrValArrayForm);
    }
    this.attrArrayIndex = null;
    // if (this.masterCatalogAttirbutes && this.masterCatalogAttirbutes.length > 0) {
    //   this.addItemtoAttributeArray();
    // }
  }


  deleteAttrVal(data: any, attrIndex: number, attrValIndex: number) {
    if (this.salsifyProduct) {
      return
    }
    const attrArray = this.attrArray.at(attrIndex) as FormGroup;
    const attrValArr = attrArray.get('attrValArray') as FormArray;
    attrValArr.removeAt(attrValIndex);
  }

 saveAttributes(autoUpdate?: boolean) {
  // Helper to check if a rich text string is genuinely empty
  const isHtmlEmpty = (val: string) => {
    if (!val) return true;
    const cleanStr = val.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
    return cleanStr === '';
  };

  // 1. Map and clean the array at the same time
  const filteredAttrArray = this.attrArrayControls
    .map((node: any) => {
      const nodeValue = node.value;
      
      // Filter out any empty attribute values from this specific node's array
      if (Array.isArray(nodeValue.attrValArray)) {
        nodeValue.attrValArray = nodeValue.attrValArray.filter(
          (val: any) => val.attributeValue && !isHtmlEmpty(val.attributeValue)
        );
      }
      return nodeValue;
    })
    // 2. Only keep parent nodes that still have at least one valid attribute value left
    .filter((nodeValue: any) => nodeValue.attrValArray && nodeValue.attrValArray.length > 0);

  // 3. If everything was stripped because it was all empty, block the save
  if (filteredAttrArray.length === 0) {
    this.inValidAttrValForm = true;
    return;
  }

  // 4. Safe to save pristine data
  this.inValidAttrValForm = false;
  let emitValue = {
    filteredAttrArray: filteredAttrArray,
    attributeFormatSwitchValue: this.attrSwitch,
    autoUpdate: autoUpdate
  };
  
  this.emitData.emit(emitValue);
}

  drop(event: CdkDragDrop<any[]>, parentCategory: any, index: number) {
    moveItemInArray(parentCategory, event.previousIndex, event.currentIndex);
    if (this.attrSwitch) {
      const attrArray = this.attrArray.at(index).get('attrValArray') as FormGroup;
      attrArray.patchValue(parentCategory);
    }
    if (!this.attrSwitch) {
      const attrArray = this.attrArray.at(index) as FormGroup;
      const attrValArr = attrArray.get('attrValArray') as FormArray;
      attrValArr.patchValue(parentCategory);
    }
  }

  collapseAll() {
    this.attrArray.value.map((node: any, index: any) => {
      this.attrArray.at(index).get('collapse');
      if (this.attrArray.at(index).get('collapse')?.value) {
        this.attrArray.at(index).get('collapse')?.patchValue(false);
      }
      else {
        this.attrArray.at(index).get('collapse')?.patchValue(true);
      }
    })
  }

  openModal(evt: any) {
    this.showModal = true;
    if(this.attrSwitch){
    this.modalMessage = "Are you sure to switch to Attribute style?";
    }
    else{
       this.modalMessage = "Are you sure to switch to Bullet style?";
    }
  }

  openClearModal(i: any) {
    this.attrArrayIndex = i;
    this.showModal = true;
    this.modalMessage = 'Are your sure to clear the changes?'
  }

  clearBulletValue(attrValArray: FormArray, index: any) {
    this.attrArrayValControls.controls.at(index)?.get('attributeValue')?.patchValue('');
  }

  confirmModalAction() {
    if (this.modalMessage == 'Are you sure to switch to Attribute style?' ||
      this.modalMessage == 'Are you sure to switch to Bullet style?'
    ) {
      this.showModal = false;
      this.inValidAttrValForm = false;
      this.attrSwitchConfirmed = this.attrSwitch;
      this.addItemtoAttributeArray();
    }
    else if (this.modalMessage == 'Are you sure to revert the changes?') {
      this.showModal = false;
      this.addEditCatalogForm.reset();
      this.inValidAttrValForm = false;
      if (this.isEditPage) {
        this.attrSwitch = this.attributeFormatSwitchValue;
        this.attrSwitchConfirmed = this.attributeFormatSwitchValue;
      }
      else {
        this.attrSwitchConfirmed = this.attrSwitch;
      }
      this.addItemtoAttributeArray();
    }
    else if (this.modalMessage == 'Are your sure to clear the changes?') {
      this.showModal = false;
      this.deleteAttrArrayItem(this.attrArrayIndex);
    }
    this.modalMessage = '';
  }

  cancelModalAction() {
    if (this.modalMessage == 'Are you sure to change the Attribute style?') {
      this.attrSwitch = !this.attrSwitch;
      this.attrSwitchConfirmed = this.attrSwitch;
    }
    this.modalMessage = '';
    this.showModal = false;
    this.attrArrayIndex = null;

  }


  verifyAttrValues() {
    const filteredAttrArray = this.attrArrayControls.filter((node: any) => {
      if (Array.isArray(node.get('attrValArray').value) && node.get('attrValArray')?.value.length > 0) {
        return node;
      }
    }).map(node1 => node1.value);

    const hasValidValue = filteredAttrArray.some(attr =>
      attr.attrValArray && attr.attrValArray.some((val: any) => val.attributeValue && val.attributeValue.trim() !== "")
    );

    if (!hasValidValue) {
      return true
    }
    else{
      return false
    }
  }

    onPaste(event: ClipboardEvent): void {
  const clipboardData = event.clipboardData;
  
  if (clipboardData && clipboardData.items) {
    const items = Array.from(clipboardData.items);
    
    // Check if any item in the clipboard is an image
    const hasImage = items.some(item => item.type.indexOf('image') !== -1);

    if (hasImage) {
      // Prevent the paste action entirely
      event.preventDefault();
      console.warn('Image pasting is disabled.');
    }
  }
}
}
